import {
    getAnonymousIdToken,
    setAnonymousIdToken,
    getAccessToken,
    removeCartIdToken,
    getCartIdToken,
    setCartCookie,
    removeAnonymousIdToken,
} from '../utils';
import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';
import type {
    AccountLoginOrRegisterSuccessResponse,
    AccountRegisterParams,
} from '@libs/common-next';

export type AnonymousId = {
    anonymousId?: string;
};

export async function getAnonymousId(): Promise<string | undefined> {
    try {
        const currentAnonymousId = getAnonymousIdToken();
        const isLoggedIn = getAccessToken();

        if (!currentAnonymousId && !isLoggedIn) {
            // change full fetch url to https://qa.in.nonprod.petsmartcloud.com/ecom/customer-web-experience/api/account/anonymousId to test locally
            const response = await cweaClient.post<AnonymousId>(
                CWEA_ENDPOINTS.account.anonymousId
            );

            const newAnonymousId = response?.anonymousId;
            if (!newAnonymousId) {
                throw new Error('Unable to get anonymous ID');
            }

            removeCartIdToken();

            setAnonymousIdToken(newAnonymousId);
            return newAnonymousId;
        }

        return currentAnonymousId;
    } catch (e) {
        console.error(e);
    }
}

export async function loginOrRegister(body?: AccountRegisterParams) {
    const anonymousCartId = getCartIdToken();
    try {
        const resCartMerge = await cweaClient.post<
            AccountLoginOrRegisterSuccessResponse,
            Partial<AccountRegisterParams>
        >(CWEA_ENDPOINTS.account.accounts, {
            body: {
                ...body,
                anonymousCartId,
            },
            additionalSuccessCodes: [400, 401, 404],
        });

        const mergedCartId =
            resCartMerge?.updatedCart?.id ?? resCartMerge?.cart?.id;
        if (mergedCartId) {
            setCartCookie(mergedCartId);
        }

        removeAnonymousIdToken();

        return resCartMerge;
    } catch (e) {
        console.error(e);
    }
}
